import React from 'react'
import styled from 'styled-components/native'
import Card from '@components/Card'
import Link from '@components/Link'
import { colors } from '@lib/colors'

const Wrapper = styled.View`
  margin-top: 10px;
`

const Text = styled.Text`
  font-size: 14px;
  line-height: 18px;
  color: ${colors.gray[500]};
  text-align: center;
`

const NoCompanyNotice: React.VFC = () => {
  return (
    <Wrapper>
      <Card>
        <Text>
          We're working to set up your profile.
          Check back soon or get in touch with us at{' '}
          <Link uri="mailto:support@spackle.co">support@spackle.co</Link>
        </Text>
      </Card>
    </Wrapper>
  )
}

export default NoCompanyNotice
